import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/retail/NavBar";
import ProductCard from "../../components/retail/ProductCard";
import RetailBanner from "../../components/retail/RetailBanner";
import SectionGrid from "../../components/retail/SectionGrid";
import HomeScreen from "../../screens/Home";
import ProductDetailsScreen from "../../screens/ProductDetails";
import ProductListingScreen from "../../screens/ProductListing";
import type { ThemeSlots } from "../types";
import "./theme.css";

/**
 * Default theme = the current app. Slot components are re-exports of
 * today's components and screens, so stores that never opt into a theme
 * render exactly what they render today.
 */
const defaultSlots: ThemeSlots = {
  header: NavBar,
  footer: Footer,
  homePage: HomeScreen,
  productListing: ProductListingScreen,
  productDetails: ProductDetailsScreen,
  heroBanner: RetailBanner,
  productCard: ProductCard,
  sectionGrid: SectionGrid,
};

export default defaultSlots;
